import React, { useContext } from 'react';
import FooterMenu from './FooterMenu';
import styled from 'styled-components';
import * as FooterConstants from '../../constants/FooterConstants';
import { footerMenuItems } from './FooterMenuItems';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

const FooterContainer = styled.footer`
  padding-left: 2em;
  padding-right: 2em;
  background-color: white;
  margin-top: auto;
`;

const FooterItems = styled.div`
  display: flex;
  align-items: center;
  height: 3em;
`;

const FooterItemLeft = styled.div`
  flex: 1;
`;

const FooterItemRight = styled.div`
  flex: none;
`;

const CopyrightTextContainer = styled.div`
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.Tarpon};
`;

export const CopyrightText = () => {
  const { commonBundle } = useContext(TranslationContext);
  return <>{commonBundle.getMessage(FooterConstants.FOOTER_COPYRIGHT_TEXT)}</>;
};

const Footer = () => {
  return (
    <FooterContainer>
      <FooterItems>
        <FooterItemLeft>
          <FooterMenu items={footerMenuItems} />
        </FooterItemLeft>
        <FooterItemRight>
          <CopyrightTextContainer>
            <CopyrightText />
          </CopyrightTextContainer>
        </FooterItemRight>
      </FooterItems>
    </FooterContainer>
  );
};

export default Footer;
